import { includes } from 'ramda';
import React, { FC, ReactNode } from 'react';

import { FlowIdTypes, FlowTypes } from '@folx-types/flow';
import { formStepFinder } from '@folx-types/flow-steps';

import ParentRoute from '../ParentRoute';

interface IMembershipInsuranceFeatureFlagParentRouteProps {
	flowId: FlowIdTypes | FlowTypes;
	path: string;
	stepKey: string;
	shouldEscapeRoute?: formStepFinder;
	skipTo?: string;
	backTo?: string;
	children?: ReactNode;
}

const MembershipInsuranceFeatureFlagParentRoute: FC<
	IMembershipInsuranceFeatureFlagParentRouteProps
> = ({ flowId, stepKey, path, backTo, skipTo, shouldEscapeRoute, children, ...props }) => {
	const enabledStates = ['MA'];

	return (
		<ParentRoute
			flowId={flowId}
			stepKey={stepKey}
			path={path}
			backTo={backTo}
			skipTo={skipTo}
			skip={({ formData }) => {
				if (formData && includes(formData?.shippingState, enabledStates)) {
					return false;
				}

				return true;
			}}
			shouldEscapeRoute={shouldEscapeRoute}
			{...props}>
			{children}
		</ParentRoute>
	);
};

export default MembershipInsuranceFeatureFlagParentRoute;
